// import { useRef, useState } from "react";
// import CustomConfirmation from "./CustomConfirmation";
// import {
//   Menu,
//   MenuItem,
//   IconButton,
//   ListItemIcon,
//   ListItemText,
// } from "@mui/material";
// import Iconify from "./Iconify";

// export default function MoreMenu({
//   handleDelete,
//   handleEdit,
//   id,
//   setEditId,
//   user = false,
//   setEditIndex,
//   index,
//   title,
// }) {
//   const ref = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const [openDelete, setOpenDelete] = useState(false);
//   const handleOk = () => {
//     handleDelete(id, index);
//     setIsOpen(false);
//   };
//   return (
//     <>
//       <CustomConfirmation
//         open={openDelete}
//         setOpen={setOpenDelete}
//         handleAgree={handleOk}
//         title={title}
//       />
//       <IconButton ref={ref} onClick={() => setIsOpen(true)}>
//         <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
//       </IconButton>

//       <Menu
//         open={isOpen}
//         anchorEl={ref.current}
//         onClose={() => setIsOpen(false)}
//         PaperProps={{
//           sx: { width: 200, maxWidth: "100%" },
//         }}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         transformOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         {!user && (
//           <MenuItem
//             // component={RouterLink}
//             // to="#"
//             sx={{ color: "text.secondary" }}
//             onClick={() => {
//               setIsOpen(false);
//               setEditId(id);
//               handleEdit();
//               setEditIndex(index);
//             }}
//           >
//             <ListItemIcon>
//               <Iconify icon="eva:edit-fill" width={24} height={24} />
//             </ListItemIcon>
//             <ListItemText
//               primary="Edit"
//               primaryTypographyProps={{ variant: "body2" }}
//             />
//           </MenuItem>
//         )}
//         <MenuItem sx={{ color: "text.secondary" }}
//         onClick={() => setOpenDelete(true) }
//         >
//           <ListItemIcon>
//             <Iconify icon="eva:trash-2-outline" width={24} height={24} />
//           </ListItemIcon>
//           <ListItemText
//             primary="Delete"
//             primaryTypographyProps={{ variant: "body2" }}
//           />
//         </MenuItem>
//       </Menu>
//     </>
//   );
// }
import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, MenuItem } from "@mui/material";
// components
import MenuPopover from "./MenuPopover";
// import { get_root_value } from "src/utils/domUtils";
// import { get_root_value } from "src/utils/domUtils";
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function MoreMenu(props) {
  const anchorRef = useRef(null);

  const {
    menu,
    data,
    index,
    width,
    isCircularOverlay,
    overlayHeight,
    overlayWidth,
  } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
  };

  const renderConetnt = () => {
    return (
      <div
        style={{ ...props.style, cursor: "pointer" }}
        className="d-flex align-items-center justify-content-center remove-border menu-background-circle more-menu-options"
      >
        <Icon
          icon={"material-symbols:more-vert"}
          width={20}
          height={20}
          ref={anchorRef}
          onClick={handleOpen}
        />
        <MenuPopover
          className="custom-popover"
          open={open}
          onClose={handleClose}
          anchorEl={anchorRef.current}
          sx={{ marginLeft: 2, minWidth: width ? width : "250px" }}
        >
          {menu.map((option) => (
            <MenuItem
              key={option.label}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen(false);
                option.handleClick({
                  state: {
                    data: data,
                    index: index,
                  },
                });
              }}
            >
              {option.icon && (
                <Icon
                  fontSize="18"
                  style={{ color: option.color }}
                  className="me-2"
                  icon={option.icon}
                />
              )}
              <span>{option.label}</span>
            </MenuItem>
          ))}
        </MenuPopover>
      </div>
    );
  };

  return (
    <>
      {isCircularOverlay ? (
        <Box
          sx={{
            height: overlayHeight ?? "35px",
            width: overlayWidth ?? "35px",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            right: 8,
            color: "white",
            backgroundColor: "rgba(0,0,0,0.2)",
            "&:hover": {
              color: "white",
              backgroundColor: "rgba(0,0,0,0.4)",
            },
          }}
          ref={anchorRef}
          onClick={handleOpen}
        >
          {renderConetnt()}
        </Box>
      ) : (
        renderConetnt()
      )}
    </>
  );
}
